module.exports = __webpack_public_path__ + "static/media/IMG_1356.5729c926.JPG";